import React, { Component } from "react";
import Swipe from 'react-swipe-component';
import ScrollableAnchor from 'react-scrollable-anchor'

import MenuOptions from "./MenuOptions"
import StoryContainer from "./StoryContainer"
import StoryArrows from "./StoryArrows"

import dataJSON from "../../api/MustKnow.json"
import "./MustKnow.scss"

class MustKnow extends Component {
  constructor() {
    super();
    this.state = {
      currItem: 0
    }
    this.isClicked = this.isClicked.bind(this);
    this.navigate = this.navigate.bind(this);
    this.onSwipeLeftListener = this._onSwipeLeftListener.bind(this);
    this.onSwipeRightListener = this._onSwipeRightListener.bind(this);
    this.onSwipeDownListener = this._onSwipeUpListener.bind(this);
    this.onSwipeUpListener = this._onSwipeDownListener.bind(this);
    this.onSwipeListener = this._onSwipeListener.bind(this);
  }
  isClicked(item) {
    if (item > this.state.currItem && item != 0) {
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'nespresso',
        'Action': 'Scroll_Category',
        'Label': "Left"
      });
    } else {
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'nespresso',
        'Action': 'Scroll_Category',
        'Label': "Right"
      });
    }
    this.setState({
      currItem: item
    });
  }
  navigate(item) {
    item = (item > dataJSON.options.length - 1 ? dataJSON.options.length - 1 : item);
    item = (item < 0 ? 0 : item);
    this.isClicked(item);
  }
  getMenuItems() {
    return dataJSON.options.map((item, index) =>
      <MenuOptions
        key={index}
        index={index}
        item={item}
        currItem={this.state.currItem}
        isClicked={this.isClicked}
      />
    )
  }
  _onSwipeLeftListener() {
    this.navigate(this.state.currItem - 1);
  }
  _onSwipeRightListener() {
    this.navigate(this.state.currItem + 1);
  }
  _onSwipeUpListener() { 
  }
  _onSwipeDownListener() { }
  _onSwipeListener(e) {
    window.scrollBy(0, e[1])
  }
  render() {
    return (
      <ScrollableAnchor id={`youmustknow`}>
      <section className="section section-mustknow">
        <div className="padding">
          <div className="container">
            <div className="headline">
              <h3>{dataJSON.text}</h3>
            </div>
            <div className="list">
              <div className="list-wrapper">
                <ul>
                  {this.getMenuItems()}
                </ul>
              </div>
            </div>
            <Swipe
              nodeName="div"
              className="container-swipe"
              mouseSwipe={false}
              onSwipedLeft={this.onSwipeLeftListener}
              onSwipedRight={this.onSwipeRightListener}
              onSwipedDown={this.onSwipeDownListener}
              onSwipedUp={this.onSwipeUpListener}
              onSwipe={this.onSwipeListener}>
              <StoryContainer item={dataJSON.options[this.state.currItem]} />
            </Swipe>
            <StoryArrows currItem={this.state.currItem} navigate={this.navigate} />
          </div>
        </div>
      </section>
      </ScrollableAnchor>
    );
  }
}

export default MustKnow;



// WEBPACK FOOTER //
// ./src/Components/MustKnow/MustKnow.js